import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    applyPrizeBoth,
    applySortPlayer
} from '../../../actions/FilterActions';
import common from '../../../common';
import config from '../../../config';

class PlayerSortByMob extends Component {

    constructor(props) {
        super(props);


    }


    onPlayerSortApply(el) {
        this.props.applySortPlayer(el);
        this.props.playerStatus.map(function (obj) {
            if (el.id == obj.id && obj.active) {

            } else {

            }
        })

    }

    render() {
        let trans = this.props.trans;



        return <div className="si-filter-types si-filter-status">
            <span className="si-title">{ trans.show ? trans.show : "show" }</span>
            <div className="sorting-wrap si-flexBox">
                { this.props.playerStatus.map(el => {

                    const className = common.makeClasses({
                        'si-sort-option': true,
                        'si-selected': el.active
                    });
                    return < div className="si-sort-box" key={ el.id } onClick={ () => this.onPlayerSortApply(el) }>
                        <div className={ className }>
                            <span className={ "si-sort-icon " + el.siIcon } ></span>
                            <span className="si-sort-tick si-flexBox"></span>
                        </div>
                        <div className="si-sort-name">{ trans[el.label] ? trans[el.label] : el.label }</div>
                    </div>
                }) }
            </div>
        </div >
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        playerStatus: state.formationData.playerFilters.playerStatus,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        applySortPlayer: (ele) => dispatch(applySortPlayer(ele)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PlayerSortByMob);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/PlayerSortByMob.js